import PanelSocial from '../../../../components/social/panelSocial';

export default PanelSocial;
